import { createSlice } from '@reduxjs/toolkit';
import { createSchedule } from "../../api/calendar/create";

export const addCalendarSlice = createSlice({
    name: 'calendar/add',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createSchedule.pending, (state, action) => {
                state.request = true;
            })
            .addCase(createSchedule.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(createSchedule.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload?.message || 'Failed to create schedule';
            })
    },
});

export const { cancelError, showError, showSuccess } = addCalendarSlice.actions

export default addCalendarSlice.reducer;
